export default {
  en: {
    a11yLabel: 'Read legal footnote',
    close: 'close',
    heading: 'Terms and conditions'
  },
  fr: {
    a11yLabel: 'Lire la note de bas de page légale',
    close: 'fermer',
    heading: 'Modalités et conditions'
  }
};